<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar title="公告列表" left-arrow @click-left="$router.go(-1)" />
    </van-sticky>
    <div class="noticeList">
      <div class="noticeItem" @click="$router.push({path:'noticeDetails',query:{noticeCon:item}})" v-for='(item,index) in noticeList' :key='index'>
        <div class="itemTitle">{{item.title}}</div>
        <div class="itemTime">{{item.create_time}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  noticeList
} from "@/api/home";
export default {
  data(){
    return{
      noticeList:[]
    }
  },
  created(){
    noticeList().then(res=>{
      this.noticeList=res;
    })
  }
};
</script>
<style lang='less' scoped>
.wrap {
  height: 100vh;
  background: #efefef;

  .noticeList {
    .noticeItem {
      width: 345px;
      box-sizing: border-box;
      margin: 10px auto;
      background: #fff;
      padding: 12.5px 10.5px;
      color: #343434;
      font-size: 14px;
      border-radius: 8.5px;
      .itemTitle {
        font-size: 16px;
        margin: 10px 0;
      }
      .itemTime{
        text-align: right;
        color:#666;
      }
    }
  }
}
</style>